module.exports = "pegasus/assets/hexagon-linkedin.png";